import React from 'react';
import { useLocation } from 'react-router-dom';
import { Chip, Divider, Avatar, Grid, Paper, TextField, IconButton, Typography, Card, CardActions, CardContent, Button } from '@material-ui/core';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
// import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';
// import TabPanel from '@mui/lab/TabPanel';
import Stack from '@mui/material/Stack';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
// Removed unavailable asset import
import { HomeCards, PracticeAreasSection, RecentCaseStudies, TestimonialsSection, ContactSection } from '../../layouts';


const styles = (theme) => ({
  pageContainer: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    overflowX: 'hidden',
    background: '#fafafa',
    fontFamily: '"Georgia", "Times New Roman", serif',
    lineHeight: 1.8,
    color: '#1a1a1a',
  },
  magazineContainer: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '60px',
    background: 'white',
    [theme.breakpoints.down('sm')]: {
      padding: '30px',
    },
  },
  heroEditorial: {
    display: 'grid',
    gridTemplateColumns: '1.2fr 0.8fr',
    gap: '60px',
    paddingBottom: '60px',
    borderBottom: '3px solid #1e3a5f',
    marginBottom: '60px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  heroMain: {
    paddingRight: '40px',
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
    },
  },
  issueLabel: {
    fontSize: '12px',
    letterSpacing: '2px',
    color: '#d4145a',
    textTransform: 'uppercase',
    fontFamily: '"Segoe UI", sans-serif',
    fontWeight: 600,
    marginBottom: '20px',
  },
  heroTitle: {
    fontSize: '64px',
    lineHeight: 1.1,
    marginBottom: '30px',
    fontWeight: 700,
    color: '#1a1a1a',
    fontFamily: '"Georgia", serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '42px',
    },
  },
  heroTitleSpan: {
    color: '#d4145a',
  },
  leadText: {
    fontSize: '22px',
    lineHeight: 1.6,
    color: '#333',
    marginBottom: '30px',
    fontStyle: 'italic',
  },
  byline: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '30px',
    fontFamily: '"Segoe UI", sans-serif',
  },
  ctaEditorial: {
    display: 'inline-block',
    background: '#1e3a5f',
    color: 'white',
    padding: '16px 40px',
    textDecoration: 'none',
    fontSize: '14px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    fontFamily: '"Segoe UI", sans-serif',
    fontWeight: 600,
    transition: 'all 0.3s',
    border: '2px solid #1e3a5f',
    '&:hover': {
      background: 'white',
      color: '#1e3a5f',
    },
  },
  heroSidebar: {
    background: '#f5f5f5',
    padding: '40px',
    borderLeft: '4px solid #d4145a',
  },
  sidebarItem: {
    marginBottom: '30px',
    paddingBottom: '30px',
    borderBottom: '1px solid #e0e0e0',
    '&:last-child': {
      borderBottom: 'none',
      marginBottom: 0,
      paddingBottom: 0,
    },
  },
  sidebarLabel: {
    fontSize: '11px',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    color: '#d4145a',
    marginBottom: '10px',
    fontFamily: '"Segoe UI", sans-serif',
    fontWeight: 600,
  },
  sidebarNumber: {
    fontSize: '48px',
    fontWeight: 700,
    color: '#1a1a1a',
    lineHeight: 1,
    marginBottom: '5px',
  },
  sidebarText: {
    fontSize: '14px',
    color: '#666',
    fontFamily: '"Segoe UI", sans-serif',
  },
  articleSection: {
    padding: '60px 0',
    borderBottom: '1px solid #e0e0e0',
    marginBottom: '60px',
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '50px',
  },
  sectionNumber: {
    fontSize: '14px',
    letterSpacing: '3px',
    color: '#d4145a',
    fontFamily: '"Segoe UI", sans-serif',
    fontWeight: 600,
  },
  sectionTitle: {
    fontSize: '48px',
    marginTop: '15px',
    marginBottom: '20px',
    fontWeight: 700,
    color: '#1a1a1a',
    fontFamily: '"Georgia", serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '32px',
    },
  },
  sectionIntro: {
    fontSize: '18px',
    color: '#555',
    maxWidth: '700px',
    margin: '0 auto',
    fontFamily: '"Segoe UI", sans-serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  twoColumnText: {
    columnCount: 2,
    columnGap: '60px',
    textAlign: 'justify',
    fontSize: '17px',
    lineHeight: 1.8,
    '& p': {
      marginBottom: '20px',
    },
    [theme.breakpoints.down('md')]: {
      columnCount: 1,
    },
  },
  dropCap: {
    '&::first-letter': {
      fontSize: '72px',
      float: 'left',
      lineHeight: 1,
      marginRight: '10px',
      color: '#d4145a',
      fontWeight: 700,
    },
  },
  quoteSection: {
    backgroundColor: '#1e3a5f',
    color: 'white',
    padding: '80px',
    margin: '60px 0',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '50px 30px',
    },
  },
  quoteMark: {
    fontSize: '120px',
    color: '#d4145a',
    position: 'absolute',
    top: '40px',
    left: '60px',
    opacity: 0.3,
  },
  quoteText: {
    fontSize: '32px',
    lineHeight: 1.5,
    fontStyle: 'italic',
    position: 'relative',
    zIndex: 2,
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
    },
  },
  quoteAuthor: {
    textAlign: 'center',
    marginTop: '30px',
    fontSize: '16px',
    color: '#d4145a',
    fontFamily: '"Segoe UI", sans-serif',
    fontStyle: 'normal',
  }
});

function Home(props) {
  const location = useLocation(); // Add the useLocation hook
  const currentPathname = location.pathname;
  
  // const classes = useStyles();
  const { classes } = props

  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.pageContainer}>
      <div className={classes.magazineContainer}>
        {/* Hero Editorial Section */}
        <section className={classes.heroEditorial}>
          <div className={classes.heroMain}>
            <div className={classes.issueLabel}>Featured Story</div>
            <Typography className={classes.heroTitle} variant="h1">
              Legal<span className={classes.heroTitleSpan}>Sutra</span>
            </Typography>
            <Typography className={classes.leadText}>
              We don't just solve problems—we create opportunities and safeguard your future.
            </Typography>
            <div className={classes.byline}>Comprehensive legal services tailored to meet your unique needs</div>
            <Button component="a" href="#contact" className={classes.ctaEditorial}>
              Schedule Consultation
            </Button>
          </div>
          <div className={classes.heroSidebar}>
            <div className={classes.sidebarItem}>
              <div className={classes.sidebarLabel}>Cases Handled</div>
              <div className={classes.sidebarNumber}>500+</div>
              <div className={classes.sidebarText}>Successful resolutions</div>
            </div>
            <div className={classes.sidebarItem}>
              <div className={classes.sidebarLabel}>Success Rate</div>
              <div className={classes.sidebarNumber}>98%</div>
              <div className={classes.sidebarText}>Favorable outcomes</div>
            </div>
            <div className={classes.sidebarItem}>
              <div className={classes.sidebarLabel}>Bar Council Affiliations</div>
              <div className={classes.sidebarNumber}>3+</div>
              <div className={classes.sidebarText}>State bar councils</div>
            </div>
          </div>
        </section>
        {/* About Article Section */}
        <section id="about" className={classes.articleSection}>
          <div className={classes.sectionHeader}>
            <div className={classes.sectionNumber}>I. INTRODUCTION</div>
            <Typography variant="h2" className={classes.sectionTitle}>About LegalSutra</Typography>
            <Typography className={classes.sectionIntro}>Your trusted partners in navigating complex legal landscapes</Typography>
          </div>
          <div className={classes.twoColumnText}>
            <Typography className={classes.dropCap}>
              At LegalSutra, we are a dedicated team of legal professionals committed to providing comprehensive and strategic legal services tailored to meet the unique needs of our clients. With Bar Council affiliations in multiple states and extensive experience in the Allahabad High Court, Delhi High Court, Mumbai High Court, and district courts across North India, we offer exceptional legal representation across a wide range of practice areas.
            </Typography>
            <Typography>
              Our approach is rooted in a deep understanding of the law, combined with practical experience across various industries. We pride ourselves on being more than just legal advisors—we are your partners in navigating complex legal landscapes.
            </Typography>
            <Typography>
              Whether you need robust support for a litigation process, meticulous contract management, or insightful legal research and analytics, our team is here to provide clear, actionable solutions that empower you to achieve your objectives. We are committed to excellence, integrity, and client satisfaction, ensuring that every case, contract, and legal issue is handled with the utmost care and professionalism.
            </Typography>
          </div>
        </section>

        {/* Quote Section */}
        <div className={classes.quoteSection}>
          <div className={classes.quoteMark}>"</div>
          <div className={classes.quoteText}>We are committed to excellence, integrity, and client satisfaction, ensuring every case is handled with the utmost care and professionalism.</div>
          <div className={classes.quoteAuthor}>— LegalSutra Mission Statement</div>
        </div>

        {/* Content Sections */}
        <PracticeAreasSection/>
        <TestimonialsSection/>
        <RecentCaseStudies/>
      </div>
      
      <ContactSection/>
    </div>
  );
};

export default withStyles(styles)(Home);
